<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :form="form" :bus="bus" icons="1">

        <trax-ui-select icon="list_alt" v-model="form.program_id" :options="programs_select"
            :placeholder="lang.polaris.training.program" :error="errors.program_id"
             v-show="programAvailable" required="1">
        </trax-ui-select>

        <trax-ui-input icon="list_alt" :value="programName" disabled="1"
            :placeholder="lang.polaris.training.program" v-show="!programAvailable">
        </trax-ui-input>

        <trax-ui-select icon="people" v-model="form.cohort_id" :options="groups_select" 
            :placeholder="lang.polaris.account.group" :error="errors.cohort_id"
            v-show="groupAvailable" required="1">
        </trax-ui-select>

        <trax-ui-input icon="people" :value="groupName" disabled="1"
            :placeholder="lang.polaris.account.group" v-show="!groupAvailable">
        </trax-ui-input>

        <trax-ui-select icon="cached" v-model="form.status" :options="status_select">
        </trax-ui-select>

        <trax-ui-datetime icon="event_available" :placeholder="lang.polaris.training.start_date"
            v-model="form.start_date" v-bind:error="errors.start_date" 
            type="date">
        </trax-ui-datetime>

        <trax-ui-datetime icon="event_busy" :placeholder="lang.polaris.training.end_date"
            v-model="form.end_date" v-bind:error="errors.end_date" 
            type="date">
        </trax-ui-datetime>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint'],
    
        data: function() {
            return {
                lang: lang,
                form: {},
                data: {},
                errors: {},
                status_select: data.status_select,
                programs_select: data.programs_select,
                groups_select: data.groups_select,
                props: {
                    id: { source:'id' },
                    cohort_id: { source:'cohort_id' },
                    program_id: { source:'program_id' },
                    status: { source:'status', default:'draft' },
                    start_date: { source:'start_date' },
                    end_date: { source:'end_date' }
                },
                titles: {
                    new: lang.polaris.training.new_registration,
                    update: lang.polaris.training.registration_update
                }
            }
        },

        computed: {

            programAvailable: function() {
                if (!this.form.program_id) return true;
                for (var index in this.programs_select) {
                    if (this.programs_select[index].value == this.form.program_id) return true;
                }
                return false;
            },

            groupAvailable: function() {
                if (!this.form.cohort_id) return true;
                for (var index in this.groups_select) {
                    if (this.groups_select[index].value == this.form.cohort_id) return true;
                }
                return false;
            },

            programName: function() {
                if (!this.program) return '';
                return this.program.name;
            },

            groupName: function() {
                if (!this.cohort) return '';
                return this.cohot.name;
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data, nativeData) {
                that.form = data;
                that.data = nativeData;
            });
        }

    }
</script>
